import React from "react";

import RefreshIcon from "@mui/icons-material/Refresh";

import ErrorImage from "@app/analytics/assets/Error.png";
import MagnifyingGlass from "@app/analytics/assets/magnifying_glass.png";
import LINKS from "@app/common/links";

import Link from "@rui/Link";

interface ErrorPageType {
  backgroundColor: string;
  cardBackgroundColor: string;
  icon: string;
  buttonIcon?: React.ReactNode;
  buttonText: string;
  title: string;
  pageTitle: string;
  subtitle?: string;
  body: React.ReactNode;
}

const ERROR_PAGE_DATA: { [key: string]: ErrorPageType } = {
  not_found: {
    pageTitle: "Not Found",
    backgroundColor:
      "linear-gradient(48.39deg, #4361EE 23.98%, #7A61FF 80.34%)",
    cardBackgroundColor: "#FFF",
    icon: MagnifyingGlass,
    buttonIcon: null,
    buttonText: "Take me to my Dashboard",
    title: "Something's missing.",
    subtitle: "404 - page not found",
    body: "The page you're looking for doesn't exist or was removed.",
  },
  crash: {
    pageTitle: "Oops!",
    backgroundColor: "#F1F4FF",
    cardBackgroundColor: "#F1F4FF",
    icon: ErrorImage,
    buttonIcon: <RefreshIcon />,
    buttonText: "Refresh page",
    title: "Let's try that again.",
    body: "This is awkward, something didn't load right. Try refreshing the page.",
  },
  server_crash: {
    pageTitle: "Server Error",
    backgroundColor: "#F1F4FF",
    cardBackgroundColor: "#F1F4FF",
    icon: ErrorImage,
    buttonIcon: null,
    buttonText: "Take me to my Dashboard",
    title: "Oops, something went wrong.",
    body: (
      <>
        There was a server error while processing your request. Please try again
        later or contact{" "}
        <Link href={LINKS.EMAIL.SUPPORT}>support@read.ai.</Link>
      </>
    ),
  },
};

export default ERROR_PAGE_DATA;
